import Vue from 'vue';
import Vuex from 'vuex';
import User from './modules/user';

Vue.use(Vuex);

let store=new Vuex.Store({
    modules:{
        user:User
    }
})
export default store;
